<template>
  <div class="pwdbox">
    <el-dialog
    title="修改密码"
    :modal-append-to-body='false'
    :visible.sync="updateDialogVisable"
    @close="clslogm"
    width="46%" :before-close="handleClose">
    <el-form ref="updateRef" :model="updateForm" status-icon :rules="updateRules" label-width="100px" label-position="left">
      <el-row :gutter="10">
        <el-col :span="18">
          <el-form-item label="绑定手机号" prop="phoneNumber">
             <el-input v-model="updateForm.phoneNumber" autocomplete="on"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
            <el-button v-if="getVcBtn==true" type="primary" @click="getVCode">获取验证码</el-button>
            <el-button v-if="getVcBtn==false" type="primary" :disabled="true"><span style="color:#fff;">{{getVcNum}}秒后可重新获取</span></el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
         <el-form-item label="验证码" prop="authCode">
            <el-input v-model="updateForm.authCode"></el-input>
         </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="18">
          <el-form-item label="原有密码" prop="oldPass">
            <el-input type="password" v-model="updateForm.oldPass" autocomplete="on"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="18">
          <el-form-item label="新密码" prop="pass">
            <el-input type="password" v-model="updateForm.pass" autocomplete="on"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="确认新密码" prop="checkPass">
            <el-input type="password" v-model="updateForm.checkPass" autocomplete="on"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="18" style="text-align:center;">
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import {
  getToken
} from '@/util/auth';
import service from '@/utils/request';
import { updatePwd } from "@/api/modules/basicData/organization";
export default {
  data () {
    var phoneNumber = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        }else{
          const reg= /^1[3|4|5|7|8][0-9]\d{8}$/;
          if(!reg.test(value)){
            return callback(new Error('手机号码格式不正确'))
          }else{
            callback();
          }
        }
        
      };
    // var authCode = (rule, value, callback) => {
    //     if (!value) {
    //       callback(new Error('验证码不能为空'));
    //     }
    //   };
    var oldPass = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('旧密码不能为空'));
        }else{
          if(value.length<6){
            return callback(new Error('密码长度在6-12位'))
          }else{
            callback(); 
          }
        }
      };
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else {
          if (this.updateForm.checkPass !== '') {
            this.$refs.updateRef.validateField('checkPass');
          }
          callback();
        }
      };
    var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.updateForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      updateForm:{
        phoneNumber:'',
        authCode:'',
        oldPass: '',
        pass: '',
        checkPass: '',
      },
      updateRules: {
        phoneNumber:[
          {validator: phoneNumber, trigger: 'blur'}
        ],
        // authCode:[
        //   {validator: authCode, trigger: 'blur'}
        // ],
        oldPass: [
          { validator: oldPass, trigger: 'blur' },
          { min: 6, max: 12, message: "长度在 6 到 12 个字符", trigger: "blur" }

        ],
        pass: [
          { validator: validatePass, trigger: 'blur' },
          { min: 6, max: 12, message: "长度在 6 到 12 个字符", trigger: "blur" }

        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        
      },
      timer: null,
      getVcNum: '',
      getVcBtn:true,
      vCode:'', //保存返回的验证码
      userCode:'',  //保存用户的code
    }
  },
  props:{
     updateDialogVisable: Boolean,
  },
  methods: {
    clslogm() {
      this.$emit("closelogm",false);
    },
    handleClose() {
      this.$emit("closeDiaPwd",false);
    },
    submitForm() {  //提交
      
      this.$refs.updateRef.validate(valid  => {
        console.log(valid);
        
        if(!valid) {
          this.openMessage('error','输入有误!')
          return
        };
      });

      if(this.updateForm.authCode == this.vCode){
        if(this.updateForm.checkPass==this.updateForm.pass){
          if(this.updateForm.authCode==this.vCode){
            this.updatePassword(getToken().account,this.updateForm.checkPass);
          }else{
            this.openMessage('error','验证码输入不正确!');
            return false;
          }
        }else{
          return false;
        }
      }else{
        this.openMessage('error','输入的验证码不正确!');
        return
      }
      
    },
    updatePassword(code,pwd){
        updatePwd(code,pwd).then(res=>{
          console.log(res);
          if(res === 1){
            this.openMessage('success','修改密码成功!');
            this.$emit("closeDiaPwd",false);
            this.$refs.updateRef.resetFields();
            this.timer=null;
            this.getVcBtn=true;
            this.$emit('closeDialog',false);
          }else if(res === -10){
            this.openMessage('error','修改密码失败!');
            return false;
          }
        });
    },
    resetForm() {  //重置
      this.$refs.updateRef.resetFields();
    },
    getVCode(){    //获取验证码
      if(this.updateForm.phoneNumber == '') {
					this.openMessage('error', '请先输入手机号码')
					return
			}
			var un = /^[1][3,4,5,7,8][0-9]{9}$/;
			if(!un.test(this.updateForm.phoneNumber)) {
				  this.openMessage('error', '请输入正确的手机号')
					return
      }
      console.log(getToken());
      
      if(this.updateForm.phoneNumber!=getToken().mobile){
        this.openMessage('error','不是本人的手机号码!')
        return
      }
        
      const TIME_COUNT = 60;
      if(!this.timer) {
					this.getVcNum = TIME_COUNT;
					this.getVcBtn = false;
					this.timer = setInterval(() => {
						if(this.getVcNum > 0 && this.getVcNum <= TIME_COUNT) {
							this.getVcNum--;
						} else {
							this.getVcBtn = true;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000);
				}
				let params = {
					phone: this.updateForm.phoneNumber
				}
				var qs = require('qs');
				service.post("sms/SendCode", qs.stringify(params)).then(res => {            
            if(res.status==200){
              res = JSON.parse(res.data);
            }
            
            console.log("res:",res.msg);
            // this.updateForm.authCode=res.msg;
						this.vCode = res.msg; //JSON.parse(res).obj.toString().substring(0, 7);
					})
					.catch(res => {
						console.log('异常原因：' + res);
					});
    },
    openMessage(type, meaasge) {  //消息提示
				this.$message({
					type: type,
					message: meaasge
				});
		},
  },

  created () {    
  },
  mounted(){
    // console.log(getToken().account);
    
  }
}
</script>

<style lang='less' scoped>
.el-button {
  padding: 12px 14px;
}
</style>
